import {
  Box,
  Breadcrumbs,
  Card,
  CardContent,
  CardHeader,
  Divider,
  Grid,
  Link,
  Typography,
} from "@material-ui/core";
import { useTheme } from "@material-ui/core/styles";
import Chart from "react-apexcharts";
import { Link as RouterLink } from "react-router-dom";
import ChevronRightIcon from "../../icons/ChevronRight";
import React, { useEffect, useState } from "react";
import { graphQLApiService } from "../../services/GraphQLApiService";
import { GET_INDEX_STATS } from "../../queries/search/indexStatsQuery";
import { format, formatISO } from "date-fns";
import { useTranslation } from "react-i18next";

const IndicesTotalOffers = () => {
  const { t } = useTranslation();
  const theme = useTheme();
  const [totalOffersAll, setTotalOffersAll] = useState([]);
  const [totalsLabels, setTotalsLabels] = useState([]);

  useEffect(() => {
    graphQLApiService
      .query(GET_INDEX_STATS, { start: formatISO(new Date()).split("T")[0] })
      .then((data: any) => {
        setTotalOffersAll(
          data.data.indexStatsHour.map((item) => item.averageOffersCount)
        );
        setTotalsLabels(
          data.data.indexStatsHour.map((item) =>
            format(new Date(item.bucket), "HH:mm")
          )
        );
      });
  }, []);

  const chart: any = {
    options: {
      chart: {
        background: "transparent",
        stacked: false,
        toolbar: {
          show: false,
        },
        zoom: false,
      },
      colors: ["#ffb547", "#7783DB"],
      dataLabels: {
        enabled: false,
      },
      fill: {
        type: "solid",
        opacity: 0,
      },
      grid: {
        borderColor: theme.palette.divider,
        strokeDashArray: 2,
      },
      markers: {
        strokeColors: theme.palette.background.paper,
        size: 6,
      },
      stroke: {
        curve: "straight",
        width: 2,
      },
      theme: {
        mode: theme.palette.mode,
      },
      tooltip: {
        theme: theme.palette.mode,
      },
      xaxis: {
        axisBorder: {
          color: theme.palette.divider,
          show: true,
        },
        axisTicks: {
          color: theme.palette.divider,
          show: true,
        },
        categories: totalsLabels,
      },
      yaxis: {
        axisBorder: {
          color: theme.palette.divider,
          show: true,
        },
        axisTicks: {
          color: theme.palette.divider,
          show: true,
        },
      },
    },
    series: [
      {
        data: totalOffersAll ? totalOffersAll.map((x) => x || 0) : [],
      },
    ],
  };

  return (
    <Grid
      container
      flexDirection="column"
      justifyContent="space-between"
      spacing={3}
      margin={1}
    >
      <Grid item>
        <Typography color="textPrimary" variant="h5">
          {t("title.Offer")}
        </Typography>
        <Breadcrumbs
          aria-label="breadcrumb"
          separator={<ChevronRightIcon fontSize="small" />}
          sx={{ mt: 1 }}
        >
          <Link
            color="textPrimary"
            component={RouterLink}
            to="/dashboard/overview"
            variant="subtitle2"
          >
            Dashboard
          </Link>
          <Link
            color="textPrimary"
            component={RouterLink}
            to="/dashboard/indices"
            variant="subtitle2"
          >
            {t("title.Indices")}
          </Link>
          <Typography color="textSecondary" variant="subtitle2">
            {t("title.Offer")}
          </Typography>
        </Breadcrumbs>
      </Grid>
      <Box
        sx={{
          backgroundColor: "background.default",
          p: 3,
          paddingRight: "64px",
        }}
      >
        <Card>
          <CardHeader title={t(`title.Offer`)} />
          <Divider />
          <CardContent>
            <Chart height="360" type="area" {...chart} />
          </CardContent>
        </Card>
      </Box>
    </Grid>
  );
};

export default IndicesTotalOffers;
